import React from "react";
import "./documentation.css";
import { CloseIcon, MagnifierIcon } from "../assets/Icons";

const SearchBox = ({
  searchValue,
  setSearchValue,
  placeholder = "",
  onCloseClick = () => setSearchValue("")
}) => (
  <>
    <div className="searchbox">
      <input
        className="documentation__search-input"
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
        placeholder={placeholder}
      />
      <MagnifierIcon className="documentation__search-magnifier" />
      {searchValue !== "" && (
        <CloseIcon
          className="documentation__search-close"
          onClick={onCloseClick}
        />
      )}
    </div>
  </>
);

export default SearchBox;
